import { QueryClient } from '@tanstack/react-query';

import { RunSyncJobCallbacks, runSyncJob, resumeSyncJob } from './run-sync-job';
import { getSyncJob, saveSyncJob } from './sync-job-store';
import { SyncJob } from './types';

let runnerActive = false;

export function isSyncRunnerActive(): boolean {
  return runnerActive;
}

export async function startSyncJob(
  queryClient: QueryClient,
  job: SyncJob,
  callbacks?: RunSyncJobCallbacks
): Promise<SyncJob> {
  if (runnerActive) {
    const existing = await getSyncJob();
    if (existing) {
      return existing;
    }
  }
  runnerActive = true;
  try {
    await saveSyncJob(job);
    return await runSyncJob(queryClient, job, callbacks);
  } finally {
    runnerActive = false;
  }
}

export async function pauseSyncJob(): Promise<SyncJob | undefined> {
  const job = await getSyncJob();
  if (!job) {
    return undefined;
  }
  const paused = { ...job, status: 'paused' as const };
  await saveSyncJob(paused);
  return paused;
}

export async function continueSyncJob(
  queryClient: QueryClient,
  callbacks?: RunSyncJobCallbacks
): Promise<SyncJob | undefined> {
  if (runnerActive) {
    return getSyncJob();
  }
  runnerActive = true;
  try {
    return await resumeSyncJob(queryClient, callbacks);
  } finally {
    runnerActive = false;
  }
}
